import axios from "./axiosInstance/npiDocumentAxios";

const show = doc_name => axios.get(`/api/v1/npi_documents/${doc_name}`);

const npiDocumentsApi = { show };

export default npiDocumentsApi;
